import { AxiosObj } from "../../Configurations/axios-setup";
import { fetchAccountId, fetchSubscriberId, fetchSubscriptionId } from "../../../utils/GetAccountDetails"

class DpodAppFlyteApi {

    constructor() {
        this.accountId = null;
        this.subscriber_id = null;
        this.subscription_id = null;
    }

    async initialize() {
        this.accountId = await fetchAccountId();
        this.subscriber_id = await fetchSubscriberId();
        this.subscription_id = await fetchSubscriptionId()
    }

    createAgentApiToken = async (reqObj) => {
        await this.initialize();
        return AxiosObj.post(`/api/ameya/${this.accountId}/subscriber/${this.subscriber_id}/subscription/${this.subscription_id}/schema_id/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/create_agent_api_token`, reqObj)
    }

    createAgentApiOrgToken = async (reqObj) => {
        await this.initialize();
        return AxiosObj.post(`/api/ameya/account/${this.accountId}/subscriber/${this.subscriber_id}/subscription/${this.subscription_id}/schema/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/create_agent_api_org_token`, reqObj)
    }

    getProjectTokens = async (last_evaluated_key, organization_id, project_id) => {
        await this.initialize();
        const queryObj = [{
            field_name: "payload.organization_id",
            field_value: organization_id,
            operator: "eq"
        },
        {
            field_name: "payload.project_id",
            field_value: project_id,
            operator: "eq"
        }]
        const filter = encodeURIComponent(JSON.stringify(queryObj))
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/agent_api_tokens?filters=${filter}&last_evaluated_key=${last_evaluated_key}&page_size=1000&include_detail=false`)
    }

    getOrgTokens = async (last_evaluated_key, organization_id) => {
        await this.initialize();
        const queryObj = [{
            field_name: "payload.organization_id",
            field_value: organization_id,
            operator: "eq"
        },
        {
            field_name: "payload.token_type",
            field_value: "agent_api_org_token",
            operator: "eq"
        }]
        const filter = encodeURIComponent(JSON.stringify(queryObj))
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/agent_api_tokens?filters=${filter}&last_evaluated_key=${last_evaluated_key}&page_size=1000&include_detail=false`)
    }

    deleteToken = async (item_Id) => {
        await this.initialize();
        return AxiosObj.delete(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID}/agent_api_token/${item_Id}`)
    }

}

const AgentApiToken = new DpodAppFlyteApi();
export default AgentApiToken;


